import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Dati legali della società che opera la piattaforma.
const COMPANY = {
  name: "Italian Mood",
  vat: "IT02234750442",
  cf: "LCDGLC74L24H321Z",
  address: "Via Gabriele d'Annunzio 28, 63074 San Benedetto del Tronto (AP)",
  phone: "0735 593839",
  email: "info@italian-mood.it",
};

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="mt-24 border-t border-ink/10 bg-cream2" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-2">
          <div className="font-display font-bold tracking-[0.2em] text-ink">ARCHI<span className="text-gold">—</span>HUB</div>
          <p className="mt-4 text-sm text-slate1 leading-relaxed max-w-xs">
            {t("footer.tagline")}
          </p>
          <div className="mt-5 text-[11px] text-slate1 leading-relaxed">
            <div className="text-ink font-medium">{COMPANY.name}</div>
            <div>{COMPANY.address}</div>
            <div>Tel. {COMPANY.phone} · <a href={`mailto:${COMPANY.email}`} className="hover:text-ink">{COMPANY.email}</a></div>
            <div>P.IVA {COMPANY.vat}</div>
            <div>C.F. {COMPANY.cf}</div>
          </div>
        </div>
        <div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-slate1">{t("footer.platform")}</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/outlet" className="text-ink hover:text-slate1 transition-colors">{t("footer.outlet")}</Link></li>
            <li><Link to="/chi-siamo#logistica" className="text-ink hover:text-slate1 transition-colors">{t("footer.white_glove")}</Link></li>
            <li><Link to="/register" className="text-ink hover:text-slate1 transition-colors">{t("footer.become_partner")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-slate1">{t("footer.studio")}</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/chi-siamo" className="text-ink hover:text-slate1 transition-colors">{t("footer.about")}</Link></li>
            <li className="text-slate1 text-xs">partners@archi-hub.it</li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-slate1">{t("footer.legal")}</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/privacy" className="text-ink hover:text-slate1 transition-colors" data-testid="footer-privacy">{t("footer.privacy")}</Link></li>
            <li><Link to="/cookie-policy" className="text-ink hover:text-slate1 transition-colors" data-testid="footer-cookies">{t("footer.cookies")}</Link></li>
            <li><Link to="/termini-condizioni" className="text-ink hover:text-slate1 transition-colors" data-testid="footer-terms">{t("footer.terms")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ink/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate1">
          <div>© {new Date().getFullYear()} ARCHI-HUB — {t("footer.tagline_bottom")}</div>
          <div className="tracking-[0.2em] uppercase">{t("footer.designed_in_italy")}</div>
        </div>
      </div>
    </footer>
  );
}
